<script>
    import Fa from 'svelte-fa'
    import AutomacaoManager from '../automacao/automacao-manager.svelte'
    import { faCog, faEdit, faRobot, faStar } from '@fortawesome/free-solid-svg-icons'
    import { Route, Link, Router } from 'yrv'
    import Content from '../_common/content.svelte'
    import NpsInfo from './nps-info.svelte'
    import NpsConfig from './nps-config.svelte'
    import Ztab from '../_common/z/ztab.svelte'

    let tabs = []
    tabs.push({ title: 'NPS', url: '/nps/info' })
    tabs.push({ title: 'Configurar', url: '/nps/config' })
</script>

<Content footer={true}>
    <div class="root-content">
        <Ztab class="h-space" {tabs}></Ztab>
        <div class="body">
            <Router>
                <Route path="/info">
                    <NpsInfo />
                </Route>
                <Route path="/config">
                    <NpsConfig />
                </Route>
            </Router>
        </div>
    </div>
</Content>
